"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tileGroupDictionary = void 0;
exports.tileGroupDictionary = {
    showMoreBtnLabel: 'Show more',
    showLessBtnLabel: 'Show less',
    enrollButton: 'Enroll',
    previousSlide: 'Accessibility label - Previous slide',
    nextSlide: 'Accessibility label - Next slide',
    goToSlide: 'Accessibility label - Go to slide',
};
